export enum priceLabel {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LIGHTEN = 'lighten',
  CAMPAIGN = 'campaign',
}

export type priceLabelStylingType =
  | priceLabel.PRIMARY
  | priceLabel.SECONDARY
  | priceLabel.LIGHTEN
  | priceLabel.CAMPAIGN;
